import { render, staticRenderFns } from "./transactionLogisticsComponent.vue?vue&type=template&id=d9ce734a&scoped=true&"
import script from "./transactionLogisticsComponent.vue?vue&type=script&lang=js&"
export * from "./transactionLogisticsComponent.vue?vue&type=script&lang=js&"
import style0 from "./transactionLogisticsComponent.vue?vue&type=style&index=0&id=d9ce734a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ce734a",
  null
  
)

export default component.exports